import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 12h6","key":"svg-0"}],["path",{"d":"M9 6v12","key":"svg-1"}],["path",{"d":"M6 18h6a6 6 0 1 0 0 -12h-6","key":"svg-2"}]]

/**
 * IconCurrencyDogecoin
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3VycmVuY3ktZG9nZWNvaW4iCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTYgMTJoNiIgLz4KICA8cGF0aCBkPSJNOSA2djEyIiAvPgogIDxwYXRoIGQ9Ik02IDE4aDZhNiA2IDAgMSAwIDAgLTEyaC02IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/currency-dogecoin
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCurrencyDogecoin = createReactComponent('outline', 'currency-dogecoin', 'CurrencyDogecoin', __iconNode);

export default IconCurrencyDogecoin;